import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle, Home, EyeOff } from 'lucide-react';
const hooks = [{
  icon: HelpCircle,
  text: 'No sabés cómo empezar a vender productos digitales'
}, {
  icon: Home,
  text: 'Querés generar ingresos online desde tu casa'
}, {
  icon: EyeOff,
  text: 'Viste gente vender ebooks pero no entendés cómo funciona'
}];
export function HooksSection() {
  return <section className="py-20 px-4 bg-dark" data-id="element-53">
      <div className="max-w-5xl mx-auto" data-id="element-54">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="font-display text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-55">
          Esto es para vos si…
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-56">
          {hooks.map((hook, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-darkCard border border-white/10 rounded-2xl p-8 hover:border-whatsapp/30 transition-all duration-300 relative overflow-hidden group" data-id="element-57">
              <div className="w-12 h-12 bg-whatsapp/10 rounded-xl flex items-center justify-center mb-6 text-whatsapp" data-id="element-58">
                <hook.icon className="w-6 h-6" data-id="element-59" />
              </div>

              <p className="text-lg font-semibold text-gray-200 leading-relaxed" data-id="element-60">
                {hook.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}